import { Box, Heading, Hidden } from 'braid-design-system';
import type { ComponentProps, ReactNode } from 'react';

interface CustomHeadingProps
  extends Omit<ComponentProps<typeof Heading>, 'level'> {
  semanticLevel: ComponentProps<typeof Heading>['component'];
  mobileLevel: ComponentProps<typeof Heading>['level'];
  tabletLevel: ComponentProps<typeof Heading>['level'];
  children: ReactNode;
  align?: 'left' | 'right' | 'center';
}

export const CustomHeading = ({
  semanticLevel,
  mobileLevel,
  tabletLevel,
  children,
  align = 'center',
}: CustomHeadingProps) => (
  <Box>
    {/* Mobile */}
    <Hidden above="mobile">
      <Heading level={mobileLevel} component={semanticLevel} align={align}>
        {children}
      </Heading>
    </Hidden>
    {/* Tablet */}
    <Hidden below="tablet">
      <Heading level={tabletLevel} component={semanticLevel} align={align}>
        {children}
      </Heading>
    </Hidden>
  </Box>
);
